const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-select-field',
        "label": '사업장명',
        "value": 'field',
        "query": {'f_id': 'fieldId', 'f_name': 'fieldName'},
        "options": {
          default: {fieldId: '', fieldName: ''},
          gridTemplateColumns: '114px auto',
        }
      },
      {'component': 'empty-space'},
      {
        'component': 'search-select-company-tree',
        "label": '부서명',
        "value": 'companyTree',
        "query": {'c0': 'company0', 'c1': 'company1', 'c2': 'company2'},
        "options": {
          default: {company0: null, company1: null, company2: null},
          gridTemplateColumns: '114px auto',
          expandAll: true,
        }
      },
      {'component': 'empty-space'},
      {
        'component': 'search-column-keyword',
        "label": '검색조건',
        "value": 'column',
        "query": {'ck_t': 'head', 'ck_k': 'keyword'},
        "options": {
          hiddenList: ['회사명', '최종 입사일', '현보직일', '총 교육이수 시간', '퇴임일'],
          gridTemplateColumns: '114px auto',
        }
      },
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 회사명
    if (search.field) {
      conditions.push({key: 'body.fields[%]', operator: '=', value: search.field.fieldId})
    }

    //  검색조건
    const heads = list.getHead().map(e => {
      return {[e.name]: e.key}
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      {
        "name": "회사명",
        "key": "body.fields[%].field_name"
      },
      {
        "name": "ID(사번)",
        "key": "body.employee_id"
      },
      {
        "name": "부서",
        "key": "body.targetCompany"
      },
      {
        "name": "구분",
        "key": "body.job_category"
      },
      {
        "name": "직종",
        "key": "body.employment_type"
      },
      {
        "name": "직급",
        "key": "body.job_title"
      },
      {
        "name": "성명",
        "key": "body.enc.full_name"
      },
      {
        "name": "최종 입사일",
        "key": "body.hire_date"
      },
      {
        "name": "현보직일",
        "key": "body.current_position_date"
      },
      {
        "name": "연락처",
        "key": "body.enc.contact_number"
      },
      {
        "name": "총 교육이수 시간",
        "key": "body.total_education_hours"
      },
      {
        "name": "퇴임일",
        "key": "body.retirement_date"
      }
    ]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: {
        // 회사명
        const fieldNames = !func.getContent(value).fieldNames ? func.getContent(value).field_names : func.getContent(value).fieldNames;
        if (fieldNames && fieldNames.length === 1) {
          return fieldNames.join(", ");
        } else if (fieldNames && fieldNames.length > 1) {
          // 만약 두번째 아이템이 4글자 이하면 첫번째와 두번째 아이템을 쉼표로 붙여서 반환한다
          if (fieldNames[1].length <= 4) {
            return `${fieldNames[0]}, ${fieldNames[1]}`;
          } else {
            return `${fieldNames[0]}, ${fieldNames[1].substring(0, 4)}...`;
          }
        } else {
          return "-";
        }
      }
      case 1:
        return func.getContent(value).employee_id; // 사번
      case 2:
        return func.getContent(value).targetCompany; // 부서
      case 3:
        return func.getContent(value).job_category; // 구분
      case 4:
        return func.getContent(value).employment_type; // 직종
      case 5:
        return func.getContent(value).job_title; // 직급
      case 6:
        return func.getContent(value).enc.full_name; // 성명
      case 7:
        return func.getContent(value).hire_date; // 최종 입사일
      case 8:
        return func.getContent(value).current_position_date; // 현보직일
      case 9:
        return func.getContent(value).enc.contact_number; // 연락처
      case 10: {
        // 총 교육이수 시간
        if (typeof value.total_education_hours === "undefined") return "0시간 0분";
        const totalEducationHours = value.total_education_hours;

        // "H시간 M분" 형식으로 변환한다.
        // 데이터는 3.5 와 같은 형식으로 저장되어 있으며 "3시간 30분" 으로 변환되야 한다.
        const hours = Math.floor(totalEducationHours);
        const minutes = Math.round((totalEducationHours - hours) * 60);
        return `${hours}시간 ${minutes}분`;
      }
      case 11:
        return func.getContent(value).retirement_date; // 퇴임일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = "created_at";
      nav.dateBegin = "nav.value.created_at.sDate";
      nav.dateEnd = "nav.value.created_at.eDate";
    }
    return {searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword, fieldId: nav.value.fieldId};
  },
  getSearchKeyword: (nav) => {
    const returnData = [];

    if (nav.value.fieldId) {
      returnData.push(`content$body.fields*%[:field_id]%`);
    }

    switch (nav.value.searchType) {
    case "회사명":
      returnData.push("content$body.stdInfo.field_name*%[:default_skw]%");
      break;
    case "ID(사번)":
      returnData.push("content$body.employee_id*%[:default_skw]%");
      break;
    case "부서":
      returnData.push("content$body.targetCompany*%[:default_skw]%");
      break;
    case "구분":
      returnData.push("content$body.job_category*%[:default_skw]%");
      break;
    case "직종":
      returnData.push("content$body.employment_type*%[:default_skw]%");
      break;
    case "직급":
      returnData.push("content$body.job_title*%[:default_skw]%");
      break;
    case "성명":
      returnData.push("content$body.full_name*%[:default_skw]%");
      break;
    case "최종 입사일":
      returnData.push("content$body.hire_date*%[:default_skw]%");
      break;
    case "현보직일":
      returnData.push("content$body.current_position_date*%[:default_skw]%");
      break;
    case "연락처":
      returnData.push("content$body.contact_number*%[:default_skw]%");
      break;
    case "총 교육이수 시간":
      returnData.push("content$body.inputC_2*%[:default_skw]%");
      break;
    case "퇴임일":
      returnData.push("content$body.retirement_date*%[:default_skw]%");
      break;
    }
    return returnData;
  },

  excelInfo: (list) => {

    return {
      filePath: '/employees/종사자_업로드_템플릿.xlsx',
      downloadFileName: '종사자 정보',
      worksheetName: (data) => {
        return '종사자 정보';
      },
      singleSheet: (worksheet, list) => {
        for (let i=0; i<list.length; i++) {
          const item = list[i];
          const body = JSON.parse(item.post_content).body;
          worksheet.addRow([
            i+1, //no
            body.employee_id, //id
            body.enc.date_of_birth, //생년월일
            body.job_category, //구분
            body.employment_type, //직종
            body.job_title, //직급
            body.enc.full_name, //성명
            body.hire_date, //입사일
            body.current_position_date, //현보직일
            body.enc.contact_number, //연락처
            body.retirement_date //퇴임일
          ])
        }
      },
    }
  }
};
export default list;
